/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:00491002-7130-49a7-a414-58a33cf05188",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_k0gUJoRGG",
    "aws_user_pools_web_client_id": "qlk459d2h8q76v3tndq186nqp",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "goginea-public-upload07ff9-dev",
    "aws_user_files_s3_bucket_region": "us-west-2",
    "aws_content_delivery_bucket": "s3uploaderui-20240711025533-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://d26en08qbx13qv.cloudfront.net"
};


export default awsmobile;
